import { Editor, T, TLBaseShape, TLShapePartial, Vec2d, deepCopy, vec2dModelValidator } from '@tldraw/tldraw'

export const MaskShapeMask = T.object({
  topLeft: vec2dModelValidator,
  bottomRight: vec2dModelValidator,
})

export type ShapeMask = T.TypeOf<typeof MaskShapeMask>
export type ShapeWithMask = TLBaseShape<string, { w: number; h: number; mask: ShapeMask }>

export function getTranslateMaskedImageChange(
  editor: Editor,
  shape: TLBaseShape<string, { w: number; h: number; mask: ShapeMask }>,
  delta: Vec2d,
) {
  if (!shape) {
    throw Error('Needs to translate a masked shape!')
  }

  const { mask: oldMask } = shape.props
  if (!oldMask) {
    // can't translate a shape that doesn't have an existing mask
    return
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  const flatten: 'x' | 'y' | null = editor.inputs.shiftKey ? (Math.abs(delta.x) < Math.abs(delta.y) ? 'x' : 'y') : null

  if (flatten === 'x') {
    delta.x = 0
  } else if (flatten === 'y') {
    delta.y = 0
  }

  delta.rot(-shape.rotation)

  // original (unmasked) width and height of shape
  const w = (1 / (oldMask.bottomRight.x - oldMask.topLeft.x)) * shape.props.w
  const h = (1 / (oldMask.bottomRight.y - oldMask.topLeft.y)) * shape.props.h

  const yMask = oldMask.bottomRight.y - oldMask.topLeft.y
  const xMask = oldMask.bottomRight.x - oldMask.topLeft.x
  const newMask = deepCopy(oldMask)

  newMask.topLeft.x = Math.min(1 - xMask, Math.max(0, newMask.topLeft.x - delta.x / w))
  newMask.topLeft.y = Math.min(1 - yMask, Math.max(0, newMask.topLeft.y - delta.y / h))

  newMask.bottomRight.x = newMask.topLeft.x + xMask
  newMask.bottomRight.y = newMask.topLeft.y + yMask

  const partial: TLShapePartial<typeof shape> = {
    id: shape.id,
    type: shape.type,
    props: {
      mask: newMask,
    },
  }

  return partial
}
